import React from 'react';

import GenericCardRenderItems from '../GenericCardRenderItems';

const DeduccOSalidasResumen = ({ data = {} }) => {
  const { DeduccOSalidas = {} } = data;

  return (
    <div className="d-block mt-2 mb-2">
      <GenericCardRenderItems
        data={DeduccOSalidas}
        width={200}
        subtitle="Importe de los Egresos del periodo de fideicomisos"
        labels={labels(DeduccOSalidas)}
      />
    </div>
  );
};

const labels = (data = {}) => {
  return [
    {
      label: 'Monto total de los egresos',
      index: 'MontTotEgresPeriodo',
    },
    {
      label: 'Parte proporcional',
      index: 'PartPropDelFideicom',
    },
    {
      label: 'Proporción del monto total',
      index: 'PropDelMontTot',
    },
    {
      label: 'Descripción del concepto',
      index: 'ConceptoS',
    },
  ];
};

export default DeduccOSalidasResumen;
